import React from "react";
import Contact from "../components/site/Contact";
import PageShell from "./PageShell";

export default function ContactPage() {
  return (
    <PageShell testid="contact-page">
      <Contact />
    </PageShell>
  );
}
